import IconBar from "../contactIconBar";

const Intro = () => {
  return (
    <div className="intro-section-inner-div">
      <h1 className="intro-section-heading-hi intro-section-item">Hi, I'm</h1>
      <h2 className="intro-section-heading-name intro-section-item">
        Abhishek Rajput
      </h2>
      <h3 className="intro-section-profile-heading intro-section-item">
        Software Engineer / Web Developer
      </h3>
      <h3 className="intro-section-build-things intro-section-item">
        I build things for the web on Cloud.
      </h3>
      <p className="intro-section-paragraph">
        I'm a Software Engineer and a passionate Full Stack Developer having 2+
        years of hands-on experience building high-performance, scalable, and
        user-centric web applications. I specialize in writing clean,
        maintainable code, optimizing performance, and delivering intuitive user
        experiences while collaborating with teams to build reliable end-to-end
        solutions.
        <br />
        Passionate about Web development and Cloud-Native technologies.
      </p>
      <div className="icon-bar-wrapper">
        <IconBar />
      </div>
    </div>
  );
};
export default Intro;
